// eslint-disable-next-line @treasury/filename-match-export
export default function parseSSN(s) {
    return s
        .replace(/\D/g, '')
        .replace(/^(\d{3})/, '$1-')
        .replace(/-(\d{2})/, '-$1-')
        .replace(/(\d)-(\d{4}).*/, '$1-$2');
}
